export const privacyContent = {
  en: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: March 16, 2025",
    sections: [
      {
        title: "Introduction",
        content: "Welcome to our website. We respect your privacy and are committed to protecting it through our compliance with this policy.\n\nThis Privacy Policy describes how we collect, use, disclose, and safeguard your information when you visit our website. We do not collect, store, or process any personal data about you when you use our website."
      },
      {
        title: "Information We Do Not Collect",
        content: "We want to be clear about our data practices:",
        list: [
          "We do not collect personal information such as your name, email address, postal address, phone number, or any other identifiers.",
          "We do not use cookies or similar tracking technologies.",
          "We do not collect information about your browsing habits or usage patterns.",
          "We do not store any customer data on our servers."
        ]
      },
      {
        title: "Third-Party Links",
        content: "Our website may contain links to third-party websites. Any information you provide to third-party sites is not covered by this Privacy Policy. We are not responsible for the privacy practices or the content of such third-party websites. We encourage you to review the privacy policies of any website you visit."
      },
      {
        title: "Changes to Our Privacy Policy",
        content: "We may update our Privacy Policy from time to time. If we make material changes to how we treat our users' information, we will post the new Privacy Policy on this page."
      },
      {
        title: "Contact Information",
        content: "If you have any questions or comments about this Privacy Policy, please contact us at: info@thairoute.com"
      }

    ]
  },
  th: {
    title: "นโยบายความเป็นส่วนตัว",
    lastUpdated: "อัปเดตล่าสุด: 16 มีนาคม 2568",
    sections: [
      {
        title: "บทนำ",
        content: "ยินดีต้อนรับสู่เว็บไซต์ของเรา เราเคารพความเป็นส่วนตัวของคุณและมุ่งมั่นที่จะปกป้องข้อมูลของคุณผ่านการปฏิบัติตามนโยบายนี้\n\nนโยบายความเป็นส่วนตัวนี้อธิบายวิธีการที่เราไม่เก็บรวบรวม ใช้ เปิดเผย และปกป้องข้อมูลของคุณเมื่อคุณเข้าชมเว็บไซต์ของเรา เราไม่เก็บรวบรวม จัดเก็บ หรือประมวลผลข้อมูลส่วนบุคคลใดๆ เกี่ยวกับคุณเมื่อคุณใช้เว็บไซต์ของเรา"
      },
      {
        title: "ข้อมูลที่เราไม่เก็บรวบรวม",
        content: "เราต้องการให้ชัดเจนเกี่ยวกับแนวปฏิบัติด้านข้อมูลของเรา:",
        list: [
          "เราไม่เก็บรวบรวมข้อมูลส่วนบุคคล เช่น ชื่อ อีเมล ที่อยู่ไปรษณีย์ หมายเลขโทรศัพท์ หรือข้อมูลระบุตัวตนอื่นๆ",
          "เราไม่ใช้คุกกี้หรือเทคโนโลยีการติดตามที่คล้ายกัน",
          "เราไม่เก็บรวบรวมข้อมูลเกี่ยวกับนิสัยการท่องเว็บหรือรูปแบบการใช้งานของคุณ",
          "เราไม่จัดเก็บข้อมูลลูกค้าใดๆ บนเซิร์ฟเวอร์ของเรา"
        ]
      },
      {
        title: "ลิงก์ไปยังเว็บไซต์บุคคลที่สาม",
        content: "เว็บไซต์ของเราอาจมีลิงก์ไปยังเว็บไซต์ของบุคคลที่สาม ข้อมูลใดๆ ที่คุณให้กับเว็บไซต์บุคคลที่สามไม่ได้อยู่ภายใต้นโยบายความเป็นส่วนตัวนี้ เราไม่รับผิดชอบต่อแนวปฏิบัติด้านความเป็นส่วนตัวหรือเนื้อหาของเว็บไซต์บุคคลที่สามดังกล่าว เราขอแนะนำให้คุณตรวจสอบนโยบายความเป็นส่วนตัวของเว็บไซต์ใดๆ ที่คุณเข้าชม"
      },
      {
        title: "การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวของเรา",
        content: "เราอาจปรับปรุงนโยบายความเป็นส่วนตัวของเราเป็นครั้งคราว หากเราทำการเปลี่ยนแปลงที่สำคัญเกี่ยวกับวิธีการที่เราปฏิบัติต่อข้อมูลของผู้ใช้ เราจะโพสต์นโยบายความเป็นส่วนตัวใหม่บนหน้านี้"
      },
      {
        title: "ข้อมูลติดต่อ",
        content: "หากคุณมีคำถามหรือความคิดเห็นเกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อเราที่: info@thairoute.com"
      }
    ]
  }
};
